import React from "react"
import {isEmpty} from "@helpers/helpers";
import {getPropertyDealTypesByCityId} from "../../models/property";
import {inArray} from "../helpers/arrays";

export const DealTypeState = {
    options: [
        {value: 'sale', label: 'خرید', checked: false},
        {value: 'rent', label: 'رهن و اجاره', checked: false},
        {value: 'mortgage', label: 'رهن کامل', checked: false},
        {value: 'pre_sale', label: 'پیش خرید', checked: false},
        {value: 'exchange', label: 'معاوضه', checked: false},
        {value: 'participation', label: 'مشارکت در ساخت', checked: false},
    ],
    selected_items: [],
};

export const getDealTypeByKey = async (deal_types, dealType) => {
    let result = '';

    if (!isEmpty(deal_types) && deal_types.options.length && !isEmpty(dealType)) {
        let dealTypeOptions = deal_types.options;
        if (typeof dealType === "string") {
            await dealTypeOptions.filter(item => {
                if (item.value === dealType) {
                    result = (item.value === 'sale') ? 'خرید فروش' : item.label;
                }
            });
        } else if (typeof dealType === "object" && dealType.length) {
            await dealTypeOptions.filter(item => {
                if (item.value === dealType[0]) {
                    result = (item.value === 'sale') ? 'خرید فروش' : item.label;
                }
            });
        }
    }

    return result;
};


export const getDealTypeOptions = async (city_id, isBadeSaba = false) => {
    const result = await getPropertyDealTypesByCityId(city_id);

    let items = [];

    if (result) {
        const hideInBadesaba = [
            'rent', 'mortgage'
        ];

        for (let deal_type of result.deal_types) {
            if (isBadeSaba && !inArray(deal_type.name, hideInBadesaba)) {
                items.push({value: deal_type.name, label: deal_type.title, checked: false})
            } else if (!isBadeSaba) {
                items.push({value: deal_type.name, label: deal_type.title, checked: false})
            }
        }
    }

    return {
        options: items,
        selected_items: [],
    };
};

export function handleRadioDealTypeOptions(options, event) {
    const {value} = event.target;
    let new_options = options;
    let selected_items = [];

    for (let key in new_options) {
        new_options[key]['checked'] = false;
        if (new_options[key]['value'] === value) {
            new_options[key]['checked'] = true;
            selected_items.push(new_options[key]['value']);
        }
    }

    return {
        options: new_options,
        selected_items: selected_items
    };
}